import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Button } from '../components/ui/Button';
import { Search, Filter, Download, Eye, RotateCcw } from 'lucide-react';
interface OrderHistoryProps {
  onNavigate: (page: string) => void;
}
export function OrderHistory({
  onNavigate
}: OrderHistoryProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const orders = [{
    id: 'PO-2023-001',
    date: '10 Okt 2023',
    items: 32,
    total: 4500000,
    status: 'in_transit',
    statusLabel: 'Dalam Pengiriman',
    eta: 'Besok, 14:00'
  }, {
    id: 'PO-2023-002',
    date: '8 Okt 2023',
    items: 18,
    total: 2100000,
    status: 'delivered',
    statusLabel: 'Terkirim',
    deliveredDate: '9 Okt 2023'
  }, {
    id: 'PO-2023-003',
    date: '5 Okt 2023',
    items: 45,
    total: 6800000,
    status: 'delivered',
    statusLabel: 'Terkirim',
    deliveredDate: '7 Okt 2023'
  }, {
    id: 'PO-2023-004',
    date: '1 Okt 2023',
    items: 28,
    total: 3200000,
    status: 'delivered',
    statusLabel: 'Terkirim',
    deliveredDate: '3 Okt 2023'
  }];
  return <div className="space-y-6" data-id="element-2759">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-2760">
        <div data-id="element-2761">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-2762">Riwayat Pesanan</h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-2763">
            Semua purchase order yang pernah dibuat
          </p>
        </div>
        <Button variant="outline" icon={<Download className="w-4 h-4" data-id="element-2765" />} data-id="element-2764">
          Ekspor Laporan
        </Button>
      </div>

      {/* Search & Filter */}
      <div className="flex gap-3" data-id="element-2766">
        <div className="relative flex-1" data-id="element-2767">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-2768" />
          <input type="text" placeholder="Cari nomor PO, tanggal, atau status..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white" data-id="element-2769" />
        </div>
        <button className="px-4 py-3 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors flex items-center gap-2" data-id="element-2770">
          <Filter className="w-5 h-5 text-slate-600" data-id="element-2771" />
          <span className="font-medium text-slate-700" data-id="element-2772">Filter</span>
        </button>
      </div>

      {/* Orders List */}
      <div className="space-y-4" data-id="element-2773">
        {orders.map(order => <Card key={order.id} className="p-6 hover:shadow-md transition-shadow" data-id="element-2774">
            <div className="flex items-start justify-between mb-4" data-id="element-2775">
              <div data-id="element-2776">
                <div className="flex items-center gap-3 mb-2" data-id="element-2777">
                  <h3 className="text-xl font-bold text-slate-900" data-id="element-2778">
                    {order.id}
                  </h3>
                  <Badge variant={order.status === 'delivered' ? 'success' : order.status === 'in_transit' ? 'warning' : 'neutral'} data-id="element-2779">
                    {order.statusLabel}
                  </Badge>
                </div>
                <p className="text-sm text-slate-500" data-id="element-2780">
                  Tanggal Pemesanan: {order.date}
                  {order.status === 'in_transit' && ` • ETA: ${order.eta}`}
                  {order.status === 'delivered' && ` • Diterima: ${order.deliveredDate}`}
                </p>
              </div>

              <div className="text-right" data-id="element-2781">
                <p className="text-sm text-slate-500 mb-1" data-id="element-2782">Total Nilai</p>
                <p className="text-2xl font-bold text-blue-600" data-id="element-2783">
                  Rp {order.total.toLocaleString('id-ID')}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-between pt-4 border-t border-slate-100" data-id="element-2784">
              <div className="flex items-center gap-6 text-sm text-slate-600" data-id="element-2785">
                <span data-id="element-2786">{order.items} Item</span>
              </div>

              <div className="flex gap-2" data-id="element-2787">
                {order.status === 'delivered' && <Button variant="outline" size="sm" icon={<RotateCcw className="w-4 h-4" data-id="element-2789" />} data-id="element-2788">
                    Pesan Ulang
                  </Button>}
                <Button variant={order.status === 'in_transit' ? 'primary' : 'outline'} size="sm" icon={<Eye className="w-4 h-4" data-id="element-2791" />} onClick={() => onNavigate('tracking')} data-id="element-2790">
                  {order.status === 'in_transit' ? 'Lacak Pesanan' : 'Lihat Detail'}
                </Button>
              </div>
            </div>
          </Card>)}
      </div>
    </div>;
}